// extracted by mini-css-extract-plugin
export var container = "styles-module__container___hO98d";
export var link = "styles-module__link___E5JNb";